import {
  Input,
  Box,
  Heading,
  Text,
  Button,
  theme,
  Flex,
  Selection,
  Select,
} from "@singita/components"

import React, { useState } from "react"
import { PhoneNumber } from "../../Forms/components"
import { validate } from "../../Forms/utils/helpers"

export const language = {
  contactInfo: {
    headline: "Contact Information",
    labelName: "Name",
    labelSurname: "Surname",
    labelEmail: "Email",
    buttonNext: "Next",
    buttonPrev: "Previous",
  },
}

const titleOptions = [
  { label: "Mr.", value: "Mr.", key: "mr" },
  { label: "Ms.", value: "Ms.", key: "ms" },
  { label: "Mrs.", value: "Mrs.", key: "mrs" },
  { label: "Dr.", value: "Dr.", key: "dr" },
  { label: "Prof.", value: "Prof.", key: "prof" },
  { label: "Other", value: "Other", key: "other" },
]

const ContactInfo = props => {
  const [errors, setErrors] = useState({})
  const {
    error,
    onChange,
    values = {},
    onSetValues,
    onPrev,
    onNext = () => {},
  } = props

  const onSubmit = async () => {
    setErrors({})

    const errors = await validate(
      [
        {
          name: "title",
          required: true,
        },
        {
          name: "name",
          required: true,
        },
        {
          name: "surname",
          required: true,
        },
        {
          name: "phone",
          type: "phone",
          required: true,
        },
        {
          name: "email",
          type: "email",
          required: true,
        },
      ],
      values
    )

    if (Object.keys(errors).length) {
      setErrors(errors)
    } else {
      onNext()
    }
  }
  return (
    <>
      <Heading variant="primary" mb={[1, 3]}>
        Contact
      </Heading>
      {error ? (
        <Box p={[2]} mt={[3]} mb={[2]} bg={theme.colors.statusError}>
          <Text color={theme.colors.baseWhite}>{error}</Text>
        </Box>
      ) : null}
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          Title
        </Text>
        <React.Suspense fallback={null}>
          <Select
            name="title"
            options={titleOptions}
            onChange={e => {
              onSetValues({ title: e.value })
            }}
            placeholder={"Select an title"}
            bg="baseGrayVeryLight"
            noOptionsMessage="No further options"
            value={titleOptions.find(o => o.value === values.title) || ""}
            error={error}
          />
        </React.Suspense>
        {errors.name ? (
          <Text color="statusError" size="small">
            {errors.name}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          {language.contactInfo.labelName}
        </Text>
        <Input
          value={values.name || ""}
          name="name"
          onChange={onChange}
          bg={theme.colors.baseGrayVeryLight}
          title="Name"
        />
        {errors.name ? (
          <Text color="statusError" size="small">
            {errors.name}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          {language.contactInfo.labelSurname}
        </Text>
        <Input
          value={values.surname || ""}
          name="surname"
          onChange={onChange}
          bg={theme.colors.baseGrayVeryLight}
          title="Surname"
        />
        {errors.surname ? (
          <Text color="statusError" size="small">
            {errors.surname}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          {language.contactInfo.labelEmail}
        </Text>
        <Input
          value={values.email || ""}
          name="email"
          onChange={onChange}
          bg={theme.colors.baseGrayVeryLight}
          title="Email"
        />
        {errors.email ? (
          <Text color="statusError" size="small">
            {errors.email}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <PhoneNumber
          label="Phone Number"
          form={{ phone: values.phone }}
          setForm={onSetValues}
          name={"phone"}
          error={errors.phone}
          bg={"baseGrayVeryLight"}
        />
      </Box>
      <Box mb={[2]}>
        <Selection
          checked={values.consent || false}
          name="consent"
          onChange={e => onSetValues({ [e.target.name]: e.target.checked })}
          label={"I consent to my submitted data being collected and stored"}
          orientation="left"
          isSpaced={false}
        />
      </Box>
      <Box mb={[2]}>
        <Selection
          checked={values.newsletter || false}
          name="newsletter"
          onChange={e => onSetValues({ [e.target.name]: e.target.checked })}
          label={
            "I would like to receive communication from Singita and its non-profit conservation partners"
          }
          orientation="left"
          isSpaced={false}
        />
      </Box>
      <Box mb={[2]}>
        <Selection
          checked={values.accf || false}
          name="accf"
          onChange={e => onSetValues({ [e.target.name]: e.target.checked })}
          label={
            "I would like to receive communication from the African Community and Conservation Foundation (ACCF), our USA 501(c)3 fiscal sponsor"
          }
          orientation="left"
          isSpaced={false}
        />
      </Box>
      <Flex justifyContent="space-between">
        {onPrev ? (
          <Box mt={[3]}>
            <Button
              variant="text"
              icon="angle-left"
              iconPosition="left"
              onClick={onPrev}
            >
              {language.contactInfo.buttonPrev}
            </Button>
          </Box>
        ) : (
          <Box />
        )}
        {onNext ? (
          <Box mt={[3]}>
            <Button
              variant="text"
              icon="angle-right"
              iconPosition="right"
              onClick={onSubmit}
            >
              {language.contactInfo.buttonNext}
            </Button>
          </Box>
        ) : null}
      </Flex>
    </>
  )
}

export default ContactInfo
